import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { check_google_calendar_linked_action, user_meta_data_action } from "../../../redux/_actions";

function useCalendar() {
  const [calendarLinked, setCalendarLinked] = useState();
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const { calendarLinkedData } = useSelector(
    (state) => state.check_google_calendar_linked_data_reducer
  );

  useEffect(() => {
    callApi();
  }, []);

  useEffect(() => {
    if (calendarLinkedData) {
      setCalendarLinked(calendarLinkedData)
    }
  }, [calendarLinkedData]);

  useEffect(() => {
    callUserMetaAction()
  }, []);



  const callUserMetaAction = async () => {
    await dispatch(user_meta_data_action())
  }

  const callApi = async () => {
    setLoading(true);
    await dispatch(check_google_calendar_linked_action());
    setLoading(false);
  };

  return {
    calendarLinked,
    loading,
  };
}

export default useCalendar;
